import { VariantResponseDto } from '@tiendanube/common';

const hasValue = (value: string | number) => Number(value) !== 0;

interface UseProductVariantsResultseShowNoWeightAndDimensionsProps
  extends Pick<VariantResponseDto, 'weight' | 'depth' | 'width' | 'height'> {
  variantId: string;
}

function useShowNoWeightAndDimension({
  variantId,
  weight,
  depth,
  width,
  height,
}: UseProductVariantsResultseShowNoWeightAndDimensionsProps) {
  const hasMessurements =
    hasValue(weight) && hasValue(depth) && hasValue(width) && hasValue(height);

  return !!variantId && !hasMessurements;
}

export default useShowNoWeightAndDimension;
